export default "__VITE_ASSET__7bb412d2__"